import Cookies from 'js-cookie';

export default () => ({
	showBanner: false,
	init() {
		let bannerClose = Cookies.get('banner-close');
		if (bannerClose !== 'true') {
			setTimeout(() => {
				this.showBanner = true;
			}, 500);
		}
	},
	closeBanner(url) {
		this.showBanner = false;
		Cookies.set('banner-close', 'true');
		if (url && url !== '') {
			window.location.href = url;
		}
	},
});
